import React from 'react'
import ClassProgressTableHeader from './ClassProgressTableHeader';

export default function ClassProgressTableHeaders(props) {
  const {scaleId, isBenchmarkOnly, isThreadOverview} = props;

  if (isThreadOverview) {
    return  (
      <div className="classProgressTableHeaderContainer">
        <ClassProgressTableHeader headerName="Word Recognition" subHeaders={["PA", "DCD", "WR"]} />
        <ClassProgressTableHeader headerName="Comprehension" subHeaders={["VCB", "CMP"]} />
        <ClassProgressTableHeader headerName="Fluency" subHeaders={["WCPM", "ARM"]} />
      </div>
    )
  }

  let scale = scaleId;
  if (scale === "ESRI") scale = "EHFWI";

  const subHeaders = [scale, "PR"]
  if (!isBenchmarkOnly) subHeaders.push("Latest");

  return (
    <div className="classProgressTableHeaderContainer">
      <ClassProgressTableHeader headerName="Fall (BOY)" subHeaders={subHeaders} />
      <ClassProgressTableHeader headerName="Winter (MOY)" subHeaders={subHeaders} />
      <ClassProgressTableHeader headerName="Spring (EOY)" subHeaders={subHeaders} />
      {scaleId === 'ARM' && <ClassProgressTableHeader headerName="Estimated Mastery Today" subHeaders={[...subHeaders].splice(0,2)} />}
    </div>
  )
}
